/**
 * CustomFieldFilterFields
 *
 * Os controles do filtro por CAMPO PERSONALIZADO. Um arquivo só, usado pelo
 * `ChatFilterDrawer` (os 4 inboxes) e pelo funil (`TagsKanbanPage`) — assim o
 * operador vê exatamente os mesmos controles nos dois lugares, que é a regra
 * da matriz de canais: se ele não sabe dizer onde está olhando, é core.
 *
 * Semântica (a mesma do motor core no backend):
 *  - campos diferentes se somam com E (restringem);
 *  - valores do mesmo campo se somam com OU (ampliam);
 *  - select/multiselect viram chips, porque as opções são fechadas e o
 *    operador não deve ter de adivinhar o texto;
 *  - texto/número viram campo livre, casando por conteúdo.
 *
 * Props:
 *  - fields   -> [{ id, name, type, options: [{id, label}] }]
 *  - values   -> [{ field_id, value }]
 *  - onChange(values)
 *  - colors   -> tema (useTheme)
 */
import React from 'react';

const CustomFieldFilterFields = ({ fields = [], values = [], onChange, colors }) => {
  if (!fields.length) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {fields.map((f) => {
        const atuais = values.filter((v) => v.field_id === f.id).map((v) => v.value);
        const trocar = (novos) => {
          const resto = values.filter((v) => v.field_id !== f.id);
          onChange?.([...resto, ...novos.map((value) => ({ field_id: f.id, value }))]);
        };
        const opcoes = f.options || [];

        return (
          <div key={f.id} style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
            <span style={{ fontSize: 11, fontWeight: 600, color: colors.textSecondary }}>
              {f.name}
            </span>

            {opcoes.length > 0 ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                {opcoes.map((o) => {
                  const on = atuais.includes(o.id);
                  return (
                    <button
                      key={o.id}
                      type="button"
                      onClick={() => trocar(
                        on ? atuais.filter((v) => v !== o.id) : [...atuais, o.id]
                      )}
                      style={{
                        padding: '6px 12px', borderRadius: 16,
                        border: `1.5px solid ${on ? colors.accentPrimary : colors.borderColor}`,
                        backgroundColor: on ? colors.accentPrimary : 'transparent',
                        color: on ? 'white' : colors.textSecondary,
                        fontSize: 12, fontWeight: 600, cursor: 'pointer',
                      }}
                    >
                      {o.label}
                    </button>
                  );
                })}
              </div>
            ) : (
              <input
                type="text"
                value={atuais[0] || ''}
                onChange={(e) => {
                  const v = e.target.value;
                  trocar(v.trim() ? [v] : []);
                }}
                placeholder={`Filtrar por ${(f.name || '').toLowerCase()}`}
                style={{
                  padding: '8px 10px', borderRadius: 8,
                  border: `1px solid ${atuais[0] ? colors.accentPrimary : colors.borderColor}`,
                  backgroundColor: colors.bgSecondary,
                  color: colors.textPrimary, fontSize: 13, outline: 'none',
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CustomFieldFilterFields;
